<template>
	<div class="all_bp">  
	    <div  v-for="BP_ROW in BP.BP_DATA" :key="BP_ROW.id" class="current_bp mt-3">
			<h1>{{BP_ROW.name}} <span class="badge badge-pill badge-warning" v-if="BP_ERRORS_COUNT>0" @click="showSwal('bp-error',BP_ERRORS)">Ошибки: {{BP_ERRORS_COUNT}}</span> <span class="badge badge-pill badge-primary"  @click="showLegend()">Легенда</span> 
			
			<base-button v-if="BP_ROW.stages.length<1" @click="AddStage(BP_ROW.id,0)" type="success" simple>Добавить первый этап</base-button></h1>
			<card class="Legend" v-if="legendIsVisib">
				<div class="col">
					<h6>Условные обозначения</h6>
					<div class="d-flex align-items-center text-info">
						<i class="tim-icons icon-refresh-02 mr-2" ></i>
						<p>Можно перезапускать в ручную</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-ic ic-phone mr-2" ></i>
						<p>Можно перезапускать из Лида</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-ic ic-hierarchy mr-2" ></i>
						<p>Это задача singleton</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-icons icon-calendar-60 mr-2" ></i>
						<p>От чего считать начало задачи: От даты из предыдущей задачи</p>
					</div>
					<p><span>С 0 &mdash; </span>через сколько часов старт</p>
					<p><span>Д 0 &mdash; </span>через сколько часов дедлайн</p>
					<p><span class="text-success">И/ИЛИ &mdash; </span>успешные входы</p>
					<p><span class="text-danger">И/ИЛИ &mdash; </span>иные входы</p>
					<div class="row align-items-center mx-0">
						<button class="btn btn-icon btn-simple btn-primary mr-2" style="height: 30px;">
							<i class="tim-icons icon-minimal-up mb-1"></i>
						</button>
						<p> &mdash; перемещение карточки задачи на 1 позицию</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="deadend deadend-success mr-2" ></i>
						<i class="deadend deadend-danger mr-2" ></i>
						<p>Тупик</p>
					</div>
					<div class="d-flex align-items-center text-danger">
						<i class="tim-ic ic-folder mr-2" ></i>
						<p class="mb-0">Архив</p>
					</div>
					<div class="d-flex align-items-center text-success">
						<i class="tim-icons icon-coins mr-2" ></i>
						<p class="mb-0">Сделка</p>
					</div>

					
				</div>
			</card>
			<div class="d-flex" id="BP_DIV_CREATOR">
				<card v-for="STAGE in BP_ROW.stages" :key="STAGE.id" header-classes="mb-5 mt-1" footer-classes="text-center mb-1 mt-5" >
					<div slot="header">
						<div class="btnsAddStage">
							<button class="left_btn btn btn-simple btn-primary" @click="AddStage(BP_ROW.id,0)"><i class="tim-icons icon-minimal-left"></i>Добавить этап</button> 
							<button class="right_btn btn btn-simple btn-primary" @click="AddStage(BP_ROW.id,STAGE.id)">Добавить этап<i class="tim-icons icon-minimal-right"></i></button>
						</div>
						<h3>
							{{ STAGE.name }} 
							
							<button class="ml-3 btn btn-icon btn-simple btn-primary" @click="EditStage(BP_ROW.id,STAGE.id)"><i class="tim-icons icon-pencil"></i></button> 
							<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="$GVO.showYesNo(function(){RemoveStage(STAGE.id);},'Удаление этапа','Вы действительно хотите удалить этап?');"><i class="tim-icons icon-trash-simple"></i></button>
						</h3>
					</div>
					<div>
						<div 
							v-for="task in STAGE.TASKS" 
							:key="task.id" 
							class="border border-primary p-2 m-3 rounded-lg task-highlight-hover " 
							@mouseenter="getHoveredCardId($event);"
							:id="'task_'+task.id" 
							:ref="'task_'+task.id" 
							:style="{'margin-left':(task.pleft*220)+'px !important'}" 
							style="width:200px; background-color: white; z-index: 10; position: relative; z-index: 1;">
							<span class="badge badge-success mr-1" v-if="task.IS_START > 0">СТАРТ</span>
							<span class="badge badge-info mr-1" >pleft {{task.pleft}}</span>
							<template v-for="tag in task.tags_list">
								<template v-for="tg in masTags">
									<span 
									
									v-if="tag == tg.id" 
									:key="tg.id"
									class="badge badge-success mr-2">{{tg.value}}</span>	
								</template>
							</template>
							<div :id="'task_in_'+task.id" class="in_round"></div>
							<div :id="'task_in_other_'+task.id" class="in_round_other"></div>
							<div class="55">
							    {{ task.pleft }}
							    {{ task.name }} 
							</div>
							<div>task.id: {{task.id}}</div>
							<div class="row my-2">
								<div class="col"><span>С {{task.START_DT_OFFSET}}, </span><span>Д {{task.DEADLINE_OFFSET}}</span></div>
								<div class="col">
									<span class="text-success"  v-if="task.successful_outcome_type === 'OR'">ИЛИ </span>
									<span class="text-success"  v-if="task.successful_outcome_type === 'AND'">И </span>
									<span class="text-danger" v-if="task.other_outcome_type === 'OR'">ИЛИ</span>
									<span class="text-danger" v-if="task.other_outcome_type === 'AND'">И</span>
								</div>
							</div>
							<div class="agent-otv">
								<b v-if="task.curator === 'agent'">Агент ответственный за услугу</b>
								<b v-if="task.curator === 'agent_head'">Начальник агента ответсвенного за услугу</b>
								<b v-if="task.curator === 'other_agent'">Сотрудник из текстового поля</b>
								<b v-if="(task.curator != 'agent') && (task.curator != 'agent_head') && (task.curator != 'other_agent') 
								&& (task.curator != 'complex_curator') && (task.curator != 'Helpdesk') && (task.curator != '')">Сотрудник из текстового поля ID {{task.curator}}</b>
								<b v-if="task.curator === 'complex_curator'">Куратор комплекса из предыдущей задачи</b>
								<b v-if="task.curator === 'Helpdesk'">Группа сотрудников из селекта</b>
							</div>

							<div class="row align-items-end mx-0">
								<div class="col-8 px-0">
									<div class="row mt-1 mx-0">
										<div class="bp-icon text-info" v-if="task.manual_retrying == 1">
											<i class="tim-icons icon-refresh-02" ></i>
										</div>
										<div class="bp-icon text-info" v-if="task.lead_retrying == 1">
											<i class="tim-ic ic-phone"></i>
										</div>
										<div class="bp-icon text-info" v-if="task.singleton == 1">
											<i class="tim-ic ic-hierarchy"></i>
										</div>
										<div class="bp-icon text-info" v-if="task.START_DT_TYPE === 'frm_input_date'">
											<i class="tim-icons icon-calendar-60"></i>
										</div>

										<template  v-for="TASKS_END in BP.TASKS_ENDS" >
											<div class="bp-icon " v-if="(task.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-3')">
												<i class="deadend" :class="[{'deadend-success': TASKS_END.ttype == 'GOOD'}, {'deadend-danger': TASKS_END.ttype == 'OTHER'}]"></i>
											</div>
										</template>
										<template  v-for="TASKS_END in BP.TASKS_ENDS" >
											<div class="bp-icon " v-if="(task.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-2')">
												<i class="tim-ic ic-folder text-danger mr-2" ></i>
											</div>
										</template>
										<template v-for="TASKS_END in BP.TASKS_ENDS">
											<div :key="TASKS_END.id" class="bp-icon " v-if="(task.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-1')">
												<i class="tim-icons icon-coins mr-2 text-success" ></i>
											</div>
										</template>
									</div>
									<div class="row mt-1">
										<button class="ml-3 mb-0 btn btn-icon btn-simple btn-primary" @click="EditTask(BP_ROW.id,STAGE.id,task.id)">
											<i class="tim-icons icon-pencil"></i>
										</button>
																														
										<button class="ml-1 mb-0 btn btn-icon btn-simple btn-danger" @click="$GVO.showYesNo(function(){RemoveTask(task.id);},'Удаление задачи','Вы действительно хотите удалить задачу?');">
											<i class="tim-icons icon-trash-simple"></i>
										</button>

									</div>
								</div>
								<div class="col-4 px-0 moveTaskOnGrid">
									<div class="row justify-content-center mx-0">
										<button class="btn btn-icon btn-simple btn-primary no-border mb-0" style="height: 15px; width: 20px;" @click="moveTaskOnGrid(task.id, 'top')">
											<i class="tim-icons icon-minimal-up"></i>
										</button>
									</div>
									<div class="row flex-nowrap justify-content-between mx-0">
										<div class="">
											<button class="btn btn-icon btn-simple btn-primary no-border my-0 " style="height: 15px; width: 20px;" @click="moveTaskOnGrid(task.id, 'left')">
												<i class="tim-icons icon-minimal-left mr-auto"></i>
											</button>
										</div>
										<div class="">
											<button class="btn btn-icon btn-simple btn-primary no-border my-0 " style="height: 15px; width: 20px;"  @click="moveTaskOnGrid(task.id, 'right')">
												<i class="tim-icons icon-minimal-right ml-auto"></i>
											</button>
										</div>
									</div>
									<div class="row justify-content-center mx-0">
										<button class="btn btn-icon btn-simple btn-primary no-border my-0" style="height: 15px; width: 20px;" @click="moveTaskOnGrid(task.id, 'bottom')">
											<i class="tim-icons icon-minimal-down"></i>
										</button>
									</div>
								</div>
							</div>
							
							<div :id="'task_out_'+task.id" class="out_round"></div>
							<div :id="'task_out_other_'+task.id" class="out_round_other"></div>
						</div>
					</div>
					<div slot="footer">
						<base-button class="w-100" @click="AddTask(BP_ROW.id,STAGE.id)" type="success" simple>Добавить задачу</base-button>
					</div>
				</card>
			</div>
	    </div>

	</div>	
</template>
<script>
import LeaderLine from 'leader-line-vue';
import swal from 'sweetalert2';
// import { elementMatches } from '@fullcalendar/core';
// import { addClass, removeClass } from 'element-ui/src/utils/dom';
// import { TimeGrid } from '@fullcalendar/timegrid'
export default {
	name: 'BP_bkp-page',
	components: {

	},
	data() {
	    return {
			BP: {},
			Plumbs:[],
			rc : 0,
			lines:[],
			BP_ERRORS: {},
			BP_ERRORS_COUNT: 0,
			bp_id: null,
			legendIsVisib: false,
			hoveredTaskId: '',
			masTags:[],
			tagsList: [],
			deadendicon: false,
			
	    };
    },
	methods: {
		checkBPid(bp_id){
			return bp_id||this.bp_id;
		},
		AddTask(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(this.bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/task?stage_id='+stage_id});
		},
		EditTask(bp_id,stage_id,task_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(bp_id,stage_id,task_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/edit/task/'+task_id});
		},
		RemoveTask(task_id){
			//console.log(task_id);
			this.$GVO.ApiCall('DEL_TASK',{obj:'BP',flt:{'id':task_id} })
			.then((objApi) => {
			    if(objApi.success === true){
				    this.$router.go();
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		AddStage(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/stage?add_after='+stage_id});
		},
		EditStage(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/edit/stage/'+stage_id});
		},
		RemoveStage(stage_id){
			//console.log(stage_id);
			this.$GVO.ApiCall('DEL_STAGE',{obj:'BP',flt:{'id':stage_id} })
			.then((objApi) => {
			    if(objApi.success === true){
				    this.$router.go();
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		refresh(){
		    this.getBP();
		},
		getBP(){
			this.$GVO.ApiCall('GET',{obj:'BP',flt:{'id':this.$route.params.bp_id, 'showall':true} })
			.then((objApi) => {
			    if(objApi.success === true){
					this.bp_id = this.$route.params.bp_id;
				    this.BP = objApi.data;
				    this.paintPlumb();
					this.$GVO.ApiCall('CHECK_BP',{obj:'BP',flt:{'id':this.bp_id} })
						.then((objApi) => {
							if(objApi.success === true && objApi.errors_count>0){
								this.BP_ERRORS_COUNT = objApi.errors_count;
								this.BP_ERRORS = objApi.errors;
								//console.log(objApi);
							}
						}).catch(errorObjApi => console.error(errorObjApi));
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getHoveredCardId(e){
			this.hoveredTaskId = e.target.id;
			let hoveredCard = document.getElementById(this.hoveredTaskId);

			for (let i = 0; i < this.Plumbs.length; i++) {
				if(this.Plumbs[i].source == this.hoveredTaskId){
					// console.log(this.Plumbs[i].source);
					let temIds = this.Plumbs[i].target.split(',');
					for(let i = 0; i < temIds.length; i++) {
						if(temIds[i] != '' && temIds[i] != 'task_' && temIds[i] > 0) { 
							let connectedCards = document.getElementById('task_' +  temIds[i]); 
							connectedCards.classList.add('task-highlight');

							hoveredCard.addEventListener('mouseleave', e => {
								connectedCards.classList.remove('task-highlight');
							});
						}
					}

				}				
			}
			
        },		

		paintPlumb(){
		    this.Plumbs=[];
		    for(let TEi in this.BP.TASKS_ENDS){ 
				let TE = this.BP.TASKS_ENDS[TEi]; //console.log(TE);
				this.Plumbs.push({source:'task_'+TE.BP_TASK_ID,target:'task_'+TE.tto});
				// if(this.Plumbs.source == this.hoveredTaskId){console.log(this.hoveredTaskId);}
				this.$nextTick(()=>{
					let line = ''; //console.log(TE.tto);
					let tto_imp = TE.tto.split(','); //console.log(tto_imp);
					for(let onet_tto in  tto_imp){ //console.log(tto_imp[onet_tto]);
						if(tto_imp[onet_tto]==''||tto_imp[onet_tto]==undefined){ continue; }
						if(onet_tto!=''){
							if(TE.ttype=='GOOD'){
								//console.log(TE.name);
								let tmp_color_arr=["#00BF9A", "#00B19A", "#00BFCA"];
								line = new LeaderLine.obj(document.getElementById('task_out_'+TE.BP_TASK_ID),document.getElementById('task_in_'+tto_imp[onet_tto]),{ color: tmp_color_arr[Math.floor(Math.random() * 3)] , size: 3, middleLabel:LeaderLine.obj.pathLabel(TE.name, {outlineColor:'none'}), path:'flow', startSocket: 'top', endSocket: 'top'});
								//line = new LeaderLine.obj(document.getElementById('task_out_'+TE.BP_TASK_ID),document.getElementById('task_in_'+tto_imp[onet_tto]),{ color: '#00BF9A' , size: 3, middleLabel:LeaderLine.obj.pathLabel(TE.name, {outlineColor:'none'}), path:'flow', startSocket: 'top', endSocket: 'top'});
							}else{
								//line = LeaderLine.setLine(document.getElementById('task_out_other_'+TE.BP_TASK_ID),document.getElementById('task_in_other_'+tto_imp[onet_tto]),{ color: '#F84E54', size: 3, middleLabel:LeaderLine.obj.pathLabel(TE.name, {outlineColor:'none'}), path:'flow', startSocket: 'bottom',endSocket: 'bottom' });
								line = new LeaderLine.obj(document.getElementById('task_out_other_'+TE.BP_TASK_ID),document.getElementById('task_in_other_'+tto_imp[onet_tto]),{ color: '#F84E54', size: 3, middleLabel:LeaderLine.obj.pathLabel(TE.name, {outlineColor:'none'}), path:'flow', startSocket: 'bottom',endSocket: 'bottom' });
							}
							//console.log(line);
							this.lines.push(line);
						}
					}
					//document.getElementById('BP_DIV_CREATOR').addEventListener('scroll', function() {  line.position(); }, false);
				});
		    }
		},
		showSwal(type,data=[]){
			if (type === 'bp-error') {
				let masErFields = [];
				let masErTasks = [];
				let iNo = 0;
				for (let key in data) {
					for (let i = 0; i < data[key].data.length; i++) {
						if(data[key].data[i].name !== null && data[key].data[i].id !== null){
							masErTasks.push(`ID: ${data[key].data[i].id} ; ИМЯ: ${data[key].data[i].name}`);
						}
					}
					if(masErTasks.length == 0){masErTasks.push('Задачи не определяются, возможно они NULL.')}
					iNo++;
					masErFields.push(`${iNo}) ${data[key].msg}: ${masErTasks.join(', ')}`);
				}
				swal({
					title: 'Ошибки в бизнес процессе',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					html: `<div class="error-content">${masErFields.join('<br>')}</div>`
				});
			}
		},
		showLegend(){
			this.legendIsVisib = !this.legendIsVisib;
		},
		moveTaskOnGrid(task_id, direction){
			this.$GVO.ApiCall('MOVE_TASK',{obj:'BP',flt:{'id':task_id}, uData:{
				'direction': direction, 
				}
			})
			.then((objApi) => {
			    if(objApi.success === true){
					this.BP = objApi.data;					
					this.getBP();
					// console.log(right);
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
	},
	mounted() {		
	    this.$nextTick(()=>{
		this.getBP();	
	    }); 
		if(typeof this.$GVO.cats.CAT_BP_TASK_TAGS == 'undefined'){
			this.$GVO.LoadCatPromise('CAT_BP_TASK_TAGS')
			.then((objApi) => {
				for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
					const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
					if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		}else{
			for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
				const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
				if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
			}
		}
	},
	beforeDestroy(){ 
		// console.log(this.lines);
	    for(let i in this.lines){
			this.lines[i].remove();
	    }
	},	    	    
};
</script>
<style scoped>
	.all_bp .card{
		display: inline-flex;
		width: auto;
		margin-right: 15px;
		min-width: 330px;
	}	
	.current_bp{ /* overflow-x: auto; */}
	.current_bp > .d-flex {width: max-content; padding-top: 40px;}
	.current_bp h1 {
		margin-bottom: 40px;
	}
	.btn-simple{padding: 10px 18px;}
	.tim-icons {padding: 0 3px 0 3px;} 
	
	.btnsAddStage{
		width: 100%;
		display: flex;
		justify-content: space-between;
		position: absolute;
		top:-60px;
		left:0px;
	}
	.all_bp .card:not(:first-of-type) .btnsAddStage .left_btn{visibility:hidden;}
	.ps__rail-y {
	 /*    display:none; */
	}
	.ps__rail-x {
	/*    display:none; */
	}	

	.btn:not(.btn-icon) .tim-icons, .navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {top: -1px;}

	h1 .badge{vertical-align: super; cursor: pointer;}

	.in_round {
            position: absolute;
	    top: -10px;
	    left: -10px;
	    border-radius: 8px;
	    background-color: #00BF9A;
	    width: 15px;
	    height: 15px;
	}
	
	.out_round {
            position: absolute;
	    top: -10px;
	    right: -10px;
	    border-radius: 8px;
	    background-color: #00BF9A;
	    width: 15px;
	    height: 15px;
	}	
	
	.in_round_other {
            position: absolute;
	    bottom: -10px;
	    left: -10px;
	    border-radius: 8px;
	    background-color: #F84E54;
	    width: 15px;
	    height: 15px;
	}
	
	.out_round_other {
            position: absolute;
	    bottom: -10px;
	    right: -10px;
	    border-radius: 8px;
	    background-color: #F84E54;
	    width: 15px;
	    height: 15px;
	}
	.bp-icon {
		width: 38px;
		padding: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.bp-icon i {font-size: 18px;}
	.Legend {
		z-index: 10;
		position: absolute;
		border: 1px solid #01b0e0;
	}
	.Legend i { font-size: 18px;}
	.moveTaskOnGrid .btn.btn-icon{
		min-width: 1rem;
		height: 15px;
	}

	.moveTaskOnGrid .btn-primary.btn-simple:hover {
		box-shadow: 2px 2px 6px rgb(0 0 0 / 40%);
	}

	.task-highlight, .task-highlight-hover:hover {
		box-shadow: 0 1px 100px 0 rgba(234, 143, 249, 1)!important;
	}

	.deadend {
		width: 20px;
		height: 20px;
		display: block;
	}
		
	.deadend-danger{
        background-image: url('/img/icons/deadend.svg');
		background-repeat: no-repeat;
    }
	.deadend-success{
        background-image: url('/img/icons/deadendsuccess.svg');
		background-repeat: no-repeat;
    }
</style>
